import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import config from 'config';
import ApplicationPage from 'site/application-page';
import BlogCategoryPage from './blog-category-page';

const GET_POSTS = gql`
    query GetPostsByCategory($categories: [String]) {
        posts(categories: $categories, limit: 25) {
            items {
                id
                slug
                title
                featureImage {
                    id
                }
                publishedAt
                category
                excerpt
            }
            cursor
            hasMore
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const DataLoader = adopt(
    {
        postsQuery: ({ categories, render }) => (
            <Query query={GET_POSTS} variables={{ categories }}>
                {render}
            </Query>
        ),
    },
    ({ postsQuery }) => ({
        error: postsQuery.error,
        loading: postsQuery.loading,
        posts: get(postsQuery, 'data.posts.items', []),
        hasMore: get(postsQuery, 'data.posts.hasMore'),
        cursor: get(postsQuery, 'data.posts.cursor'),
        fetchMore: postsQuery.fetchMore,
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

const BlogCategoryPageContainer = ({ match }) => {
    const { categories, ...data } = config('/blog/sections').find(
        x => x.slug === match.params.category
    );

    return (
        <ApplicationPage>
            <DataLoader categories={categories}>
                {({ error, loading, posts, hasMore, cursor, fetchMore }) => {
                    if (error) throw error;
                    if (loading && !posts.length) return null;
                    return (
                        <BlogCategoryPage
                            {...data}
                            slug={match.params.category}
                            posts={posts}
                            hasMore={hasMore}
                            onLoadMore={() =>
                                fetchMore({
                                    variables: { cursor },
                                    updateQuery: (prev, { fetchMoreResult }) => {
                                        const result = get(fetchMoreResult, 'posts', {});
                                        return {
                                            ...prev,
                                            posts: {
                                                ...result,
                                                items: [...prev.posts.items, ...result.items],
                                            },
                                        };
                                    },
                                })
                            }
                        />
                    );
                }}
            </DataLoader>
        </ApplicationPage>
    );
};

BlogCategoryPageContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            category: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default BlogCategoryPageContainer;
